import React, { useEffect, useState } from 'react'
import InputField from '../../common/InputField'
import DetailHeaderBar from '../../common/DetailHeaderBar'
import FormActionRow from '../../common/FormActionRow'
import apiServer from "../../constants/apiServer";
import { put } from '../../utils/api';
import SquareLoading from "../../common/SquareLoading";
import EmptyPage from '../../common/EmptyPage';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AdaAlert from '../../common/AdaAlert';
import PopupLoading from "../../common/PopupLoading";
import useFetchInfo from "../../utils/useFetchInfo";
import { useLocation } from 'react-router-dom';
import { checkFormValidate } from "../../utils/commonFuncs";
import { handleApiError, handleApiSuccess } from "../../utils/errorHandler";


const EditOperator = () => {
 
  const { operatorId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const [operatorInfoValues, setOperatorInfoValues] = useState({
    email: "",
    password: "",
    name: "",
    phone: "",
    showPassword: false,
    role_id: 1, // default role
    status: 1 // default active status
  });

  const [infoLoading, setInfoLoading] = useState(true);
  const [getInfoError, setGetErrorInfo] = useState("");

  const [errorValues, setErrorValues] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");


  const { data, isLoading, error } = useFetchInfo(`${apiServer.operator.getDetail}/${operatorId}`);

  useEffect(()=> {
    if (data) {
      setOperatorInfoValues({
        email: data.email || "",
        password: "",
        name: data.name || "",
        phone: data.phone || "",
        showPassword: false,
        role_id: data.role_id || 1,
        status: data.status !== undefined ? data.status : 1
      });
    }
    setInfoLoading(isLoading);
    setGetErrorInfo(error);
  },[data, isLoading, error])


  const handleChangeValue = (event) => {
    const { name, value } = event.target;
    setOperatorInfoValues((operatorInfo) => {
      return {
        ...operatorInfo,
        [name]: value
      };
    });
  };

  const handleChangePasswordType = () => {
    setOperatorInfoValues((operatorInfo) => {
      return {
        ...operatorInfo,
        showPassword: !operatorInfo["showPassword"]
      };
    });
  };

  const handleEdit = async(event) => {
    event.preventDefault();
    const { email, password, name, phone, role_id, status } = operatorInfoValues;
    
    const checkGeneralInfo = checkFormValidate({
      email,
      password,
      name,
      phone,
    });
    setErrorValues(checkGeneralInfo);
    const errorStateList = Object.keys(checkGeneralInfo);
    
    if (errorStateList.length === 0 && email.length < 200 && password.length < 200) {
      setEditLoading(true);

      const fd = new FormData();
      fd.append("name", name);
      fd.append("phone", phone);
      fd.append("email", email);
      fd.append("password", password);
      fd.append("role_id", role_id);
      fd.append("status", status);

      const updateOperatorURL = `${apiServer.operator.update}/${operatorId}`;
      
      try {
        const response = await put(updateOperatorURL, fd);
        const responseData = handleApiSuccess(response, setEditLoading);
        
        navigate('/operators', { 
          replace: true, 
          state: { status: 'success', message: responseData.message } 
        });
      } catch (errors) {
        handleApiError(errors, setErrorEdit, setEditLoading);
      }
    }
  };

  if(infoLoading) return <SquareLoading text="Retrieving Data" />

  if(getInfoError) return <EmptyPage text={getInfoError} />

  return (
    <>
      <div className="create-operator-container">
        <DetailHeaderBar navigateRoute={"/operators"} name="Update Operator" />
        <div className="create-operator-form-container">
          <form className="create-operator-form" onSubmit={handleEdit}>
            <InputField
              title="Email"
              type="email"
              name="email"
              value={operatorInfoValues.email}
              width="250px"
              id="operator_create"
              isRequired
              isFlag={'email' in errorValues || operatorInfoValues.email?.length > 200}
              errMsg={operatorInfoValues.email?.length > 200 ? "Must not exceed more than 200 words" : errorValues['email']}
              onChange={handleChangeValue}
            />
            <InputField
              title="Password"
              type={operatorInfoValues.showPassword ? "text" : "password"}
              name="password"
              value={operatorInfoValues.password}
              width="250px"
              isRequired
              id="operator_password"
              fieldType="password"
              isFlag={'password' in errorValues || operatorInfoValues.password?.length > 200}
              errMsg={operatorInfoValues.password?.length > 200 ? "Must not exceed more than 200 words" : errorValues['password']}
              onShowPassword={handleChangePasswordType}
              onChange={handleChangeValue}
            />
            <InputField
              title="Name"
              type="text"
              name='name'
              value={operatorInfoValues.name}
              width="250px"
              id="operator_name"
              isRequired
              isFlag={'name' in errorValues}
              errMsg={errorValues?.name}
              onChange={handleChangeValue}
            />
            <InputField
              title="Phone"
              type="text"
              id="operator_phone"
              name="phone"
              value={operatorInfoValues.phone}
              width="250px"
              onChange={handleChangeValue}
            />
            <FormActionRow submitBtnName="Update" onCancel={()=>{ navigate('/operators', { replace: true })} } />
          </form>
        </div>
      </div>
      {editLoading && <PopupLoading text={"Modifying Operator Information..."} />}
      {errorEdit && <AdaAlert type="error" message={errorEdit} />}
    </>
  )
}

export default EditOperator